import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home" }

import MainBanner from '@/components/sections/MainBanner.vue';
import EbooksCarousel from '@/components/sections/EbooksCarousel.vue';
import InfoSection from '@/components/sections/InfoSection.vue';
import TestimonialsSection from '@/components/sections/TestimonialsSection.vue';
// ... outros imports

export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_ProductCarousel = _resolveComponent("ProductCarousel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(MainBanner),
    _createVNode(_component_ProductCarousel),
    _createVNode(EbooksCarousel),
    _createVNode(InfoSection),
    _createVNode(TestimonialsSection),
    _cache[0] || (_cache[0] = _createElementVNode("section", { class: "container" }, null, -1))
  ]))
}
}

})